import React, { useRef } from "react";
import { observer } from "mobx-react-lite";
import { Menu, MenuItem } from "@mui/material";

import { Settings as SettingsSvg } from "../../svg/svgImageList";
import Button from "../../button/Button";
import { videoPlayerService } from "../../../services/video-player/VideoPlayerService";
import useModal from "../../dialog/useModal";
import Checkbox from "../../checkbox/Checkbox";
import Tooltip, { ComponentWithTooltipProps } from "../../tooltip/Tooltip";

const elementId = "video-settings-control";

const HighlightSettings = observer(({ tooltipTextKey }: ComponentWithTooltipProps) => {
  const { showArea, showContour, showBox, changeShowArea, changeShowContour, changeShowBox } =
    videoPlayerService;
  const ref = useRef(null);

  const { isVisible, toggleModal } = useModal();
  const settingsButtonRef = useRef(null);

  return (
    <div ref={ref}>
      <Tooltip id={elementId} title={tooltipTextKey}>
        <Button
          id={elementId}
          onClick={toggleModal}
          ref={settingsButtonRef}
          icon={{
            svg: SettingsSvg,
            className: `settings-control`,
          }}
        />
      </Tooltip>
      <Menu
        id="basic-menu"
        container={ref.current}
        anchorEl={settingsButtonRef.current}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        transformOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={isVisible}
        onClose={toggleModal}
      >
        <MenuItem>
          <Checkbox
            checked={showArea}
            onChange={changeShowArea}
            labelKey="VideoAnalysis.video-settings.show-area"
          />
        </MenuItem>
        <MenuItem>
          <Checkbox
            checked={showContour}
            onChange={changeShowContour}
            labelKey="VideoAnalysis.video-settings.show-contour"
          />
        </MenuItem>
        <MenuItem>
          <Checkbox
            checked={showBox}
            onChange={changeShowBox}
            labelKey="VideoAnalysis.video-settings.show-box"
          />
        </MenuItem>
      </Menu>
    </div>
  );
});

export default HighlightSettings;
